export enum TASK_STATUS {
  PLANNED = 1,
  "IN PROGRESS",
  "UNDER REVIEW",
  "COMPLETED",
  "ON HOLD"
}
